import {
  onSwitchToAnalytics,
  onSwitchToAnalyticsBellCurveReport,
} from "./mdae-menu-click-handlers";
import {
  openCodeLookupWindow,
  mdaiMenuClickHandlers,
  MDAI_MODULE,
  IMdaiSettings,
} from "./mdae-menu-click-handlers";
export const APP_LAYOUT_THEME = {
  EAT: "EAT",
  AUDIT: "AUDIT",
  ANALYTICS: "ANALYTICS",
};
export const analyticsNavigateAccess = false;
const getMatchingUrlStaticConfig = (menuId) => {
  if (!menuId) return;
  for (
    let i = 0;
    i < mdaeNewNavigationBarConfig.auditsSectionMenuItemList.length;
    i++
  ) {
    if (
      mdaeNewNavigationBarConfig.auditsSectionMenuItemList[i].menuId === menuId
    ) {
      return mdaeNewNavigationBarConfig.auditsSectionMenuItemList[i];
    }
  }
};
export const URL_THEME_MAPPING = {};
URL_THEME_MAPPING[APP_LAYOUT_THEME.EAT] = [
  "/externalaudit/dashboard",
  "/externalaudit/allaudits",
  "/externalaudit/mytasks",
  "/externalaudit/taskhq",
  "/externalaudit/manualaudit",
  "/externalaudit/audit",
  "/externalaudit/deletedexternalaudits",
  "/externalaudit/deletedexternalcases",
  "/externalaudit/admin/requester",
  "/externalaudit/admin/processtemplate",
  "/externalaudit/admin/documentmanagement",
  "/externalaudit/admin/requesterandsource",
  "/externalaudit/admin/processtemplate",
  "/externalaudit/admin/tasktemplates",
  "/audit/externalaudit",
  "/externalaudit/admin/caseoutcomes",
  "/externalaudit/admin/categorymanagement",
  "/externalaudit/deletedexternalcases",
  "/externalaudit/admin/contenttypes",
  "/externalaudit/mdai/departmentsummary",
  "/externalaudit/mdai/requestersummary",
  "/externalaudit/mdai/externalauditresults",
  "/externalaudit/mdai/externalaudittargets",
  "/externalaudit/admin/denialreasons",
  "/externalaudit/usermanagement/externalusers",
  "/externalaudit/mdai/eawbenchmarks",
  "/externalaudit/usermanagement/taskgroups",
  "/externalaudit/emdrinbox",
  "/externalaudit/emdrenrollment",
  "/externalaudit/admin/targetrationale",
  "/externalaudit/caselist",
  "/externalaudit/casesearch",
  "/externalaudit/customersetup/dataconfiguration",
  "/externalaudit/externalaudithistory",
  "/externalaudit/policysearch",
];
URL_THEME_MAPPING[APP_LAYOUT_THEME.ANALYTICS] = [
  "/analyzer/denialspredictor",
  "/Analyzer/emutilizationconfig",
  "/mdai/allinsights",
  "/mdai/SpotIQResults",
  "/mdai/selfsearch",
  "/mdai/auditactivitysummaryinternal",
  "/mdai/auditactivitysummaryexternal",
  "/mdai/auditresultssummaryexecutive",
  "/mdai/auditresultssummaryfocused",
  "/mdai/auditresultssummaryprovidergrouprisks",
  "/mdai/audittargetanalysesIP",
  "/mdai/audittargetanalysesOP",
  "/mdai/audittargetanalysesprofessional",
  "/mdai/procedureutilization",
  "/mdai/procedureutilization/hospitalclaims",
  "/mdai/executiveoverview",
  "/mdai/executiveoverviewcmiscores",
  "/mdai/denialtrendinganalysis",
  "/mdai/targeteddenialanalysisprofessional",
  "/mdai/targeteddenialanalysisinstitutional",
  "/analyzer/riskareaoutcomes",
  "/mdai/auditroi",
  "/mdai/payerauditroi",
  "/mdai/chargepaymentanalyses",
  "/mdai/professionalproviderrisk",
  "/mdai/professionalcoderrisk",
  "/mdai/professionalpayerrisk/",
  "/mdai/professionaltopcodes/",
  "/mdai/outpatientfacilityrisk/",
  "/mdai/outpatientcoderrisk/",
  "/mdai/outpatientpayerrisk/",
  "/mdai/outpatienttopcodes/",
  "/mdai/inpatientfacilityrisk/",
  "/mdai/inpatientcoderrisk/",
  "/mdai/inpatientpayerrisk/",
  "/mdai/inpatienttopcodes/",
  "/analyzer/policysearch"
];

const mdaeNewNavigationBarConfig = {
  auditsSectionMenuItemList: [
    {
      id: 0,
      isMainMenuListItem: false,
      selected: false,
      visible: true,
      isMdaeNavigationBarExpanded: true,
      disabled: false,
      isMenuSelected: false,
      title: "",
      pageTitle: "",
      menuUrl: "",
      mdaeMenuClickHandler: null,
      iconClassName: "",
      menuId: 0,
    },
    {
      menuId: 507,
      isReactMenu: true,
    },
    {
      menuId: 514,
      isReactMenu: true,
    },

    {
      menuId: 541,
      isReactMenu: true,
    },
    {
      menuId: 539,
      isReactMenu: true,
    },
    {
      menuId: 641,
      isOpenInNewTab: true,
      mdaeMenuClickHandler: openCodeLookupWindow,
    },
    {
      menuId: 2,
      isOpenInNewTab: true,
      mdaeMenuClickHandler: onSwitchToAnalytics,
    },
    {
      menuId: 510,
      isOpenInNewTab: true,
      mdaeMenuClickHandler: onSwitchToAnalytics,
    },
    {
      menuId: 500,
      isReactMenu: true,
    },
    {
      menuId: 517,
      isReactMenu: true,
    },
    {
      menuId: 515,
      isReactMenu: true,
    },
    {
      menuId: 501,
      isReactMenu: true,
    },
    {
      menuId: 529,
      isReactMenu: true,
    },
    {
      menuId: 502,
      isReactMenu: true,
    },
    {
      menuId: 503,
      isReactMenu: true,
    },
    {
      menuId: 508,
      isOpenInNewTab: true,
      isReactMenu: true,
    },
    {
      menuId: 3,
      isMatchMenuUrlSearch: true,
    },
    {
      menuId: 8,
      matchUrl: "/searchcriteria/add",
    },
    {
      menuId: 12,
      isOpenInNewTab: true,
    },
    {
      menuId: 13,
      isOpenInNewTab: true,
    },
    {
      menuId: 637,
      mdaeMenuClickHandler: openCodeLookupWindow,
    },
    {
      menuId: 639,
      mdaeMenuClickHandler: openCodeLookupWindow,
    },
    {
      menuId: 71,
      isMatchMenuUrlSearch: true,
    },
    {
      menuId: 72,
      isMatchMenuUrlSearch: true,
    },
    {
      menuId: 500,
      isReactMenu: true,
    },
    {
      menuId: 500,
      isReactMenu: true,
    },
    {
      menuId: 46,
      menuUrl: undefined,
      mdaiModule: MDAI_MODULE.AUDIT_INSIGHTS,
      mdaeMenuClickHandler:
        mdaiMenuClickHandlers.onAccessThoughtSpotAuditActivitySummaryInternal,
    },
    {
      menuId: 47,
      menuUrl: undefined,
      mdaiModule: MDAI_MODULE.AUDIT_INSIGHTS,
      mdaeMenuClickHandler:
        mdaiMenuClickHandlers.onAccessThoughtSpotAuditActivitySummaryExternal,
    },
    {
      menuId: 48,
      menuUrl: undefined,
      mdaiModule: MDAI_MODULE.AUDIT_INSIGHTS,
      mdaeMenuClickHandler:
        mdaiMenuClickHandlers.onAccessThoughtSpotAuditResultsSummaryExecutive,
    },
    {
      menuId: 49,
      menuUrl: undefined,
      mdaiModule: MDAI_MODULE.AUDIT_INSIGHTS,
      mdaeMenuClickHandler:
        mdaiMenuClickHandlers.onAccessThoughtSpotAuditResultsSummaryFocused,
    },
    {
      menuId: 50,
      menuUrl: undefined,
      mdaiModule: MDAI_MODULE.AUDIT_INSIGHTS,
      mdaeMenuClickHandler:
        mdaiMenuClickHandlers.onAccessThoughtSpotAuditTargetAnalysesIP,
    },
    {
      menuId: 51,
      menuUrl: undefined,
      mdaiModule: MDAI_MODULE.AUDIT_INSIGHTS,
      mdaeMenuClickHandler:
        mdaiMenuClickHandlers.onAccessThoughtSpotAuditTargetAnalysesOP,
    },
    {
      menuId: 52,
      menuUrl: undefined,
      mdaiModule: MDAI_MODULE.AUDIT_INSIGHTS,
      mdaeMenuClickHandler:
        mdaiMenuClickHandlers.onAccessThoughtSpotAuditTargetAnalysesProfessional,
    },
    {
      menuId: 544,
      menuUrl: undefined,
      mdaiModule: MDAI_MODULE.AUDIT_INSIGHTS,
      mdaeMenuClickHandler:
        mdaiMenuClickHandlers.onAccessThoughtSpotSelfServiceSearch,
    },
    {
      menuId: 76,
      matchUrl: "/mdai/executiveoverview/",
      menuUrl: undefined,
      mdaiModule: MDAI_MODULE.REVENUE_OPTIMIZER,
      mdaeMenuClickHandler:
        mdaiMenuClickHandlers.onAccessThoughtSpotExecutiveOverviewReports,
    },
    {
      menuId: 77,
      matchUrl: "/mdai/executiveoverviewcmiscores/",
      menuUrl: undefined,
      mdaiModule: MDAI_MODULE.REVENUE_OPTIMIZER,
      mdaeMenuClickHandler:
        mdaiMenuClickHandlers.onAccessThoughtSpotExecutiveOverviewCMIScoresReports,
    },
    {
      menuId: 78,
      matchUrl: "/mdai/denialtrendinganalysis/",
      menuUrl: undefined,
      mdaiModule: MDAI_MODULE.REVENUE_OPTIMIZER,
      mdaeMenuClickHandler:
        mdaiMenuClickHandlers.onAccessThoughtSpotDenialTrendingAnalysisReports,
    },
    {
      menuId: 79,
      matchUrl: "/mdai/targeteddenialanalysisprofessional/",
      menuUrl: undefined,
      mdaiModule: MDAI_MODULE.REVENUE_OPTIMIZER,
      mdaeMenuClickHandler:
        mdaiMenuClickHandlers.onAccessThoughtSpotDenialTrendingAnalysisProfessionalReports,
    },
    {
      title: "Institutional",
      menuId: 80,
      menuUrl: undefined,
      matchUrl: "/mdai/targeteddenialanalysisinstitutional/",
      mdaiModule: MDAI_MODULE.REVENUE_OPTIMIZER,
      mdaeMenuClickHandler:
        mdaiMenuClickHandlers.onAccessThoughtSpotDenialTrendingAnalysisInstitutionalReports,
    },
    {
      menuId: 81,
      matchUrl: "/mdai/selfsearch?isforro=true",
      isMatchMenuUrlSearch: true,
      menuUrl: undefined,
      mdaiModule: MDAI_MODULE.REVENUE_OPTIMIZER,
      mdaeMenuClickHandler:
        mdaiMenuClickHandlers.onAccessThoughtSpotRoSelfServiceSearch,
    },
    {
      menuId: 82,
      matchUrl: "/mdai/allinsights?isforro=true",
      menuUrl: undefined,
      mdaiModule: MDAI_MODULE.REVENUE_OPTIMIZER,
      mdaeMenuClickHandler:
        mdaiMenuClickHandlers.onAccessThoughtSpotRoAllInsights,
    },
    {
      menuId: 83,
      matchUrl: "/mdai/auditactivitysummaryinternal/",
      menuUrl: undefined,
      mdaiModule: MDAI_MODULE.AUDIT_INSIGHTS,
      mdaeMenuClickHandler:
        mdaiMenuClickHandlers.onAccessThoughtSpotAuditActivitySummaryInternal,
    },
    {
      menuId: 84,
      matchUrl: "/mdai/auditactivitysummaryexternal/",
      menuUrl: undefined,
      mdaiModule: MDAI_MODULE.AUDIT_INSIGHTS,
      mdaeMenuClickHandler:
        mdaiMenuClickHandlers.onAccessThoughtSpotAuditActivitySummaryExternal,
    },
    {
      menuId: 85,
      matchUrl: "/mdai/auditresultssummaryexecutive/",
      menuUrl: undefined,
      mdaiModule: MDAI_MODULE.AUDIT_INSIGHTS,
      mdaeMenuClickHandler:
        mdaiMenuClickHandlers.onAccessThoughtSpotAuditResultsSummaryExecutive,
    },
    {
      menuId: 86,
      matchUrl: "/mdai/auditresultssummaryfocused/",
      menuUrl: undefined,
      mdaiModule: MDAI_MODULE.AUDIT_INSIGHTS,
      mdaeMenuClickHandler:
        mdaiMenuClickHandlers.onAccessThoughtSpotAuditResultsSummaryFocused,
    },
    {
      menuId: 87,
      matchUrl: "/mdai/audittargetanalysesIP/",
      menuUrl: undefined,
      mdaiModule: MDAI_MODULE.AUDIT_INSIGHTS,
      mdaeMenuClickHandler:
        mdaiMenuClickHandlers.onAccessThoughtSpotAuditTargetAnalysesIP,
    },
    {
      menuId: 88,
      matchUrl: "/mdai/audittargetanalysesOP/",
      menuUrl: undefined,
      mdaiModule: MDAI_MODULE.AUDIT_INSIGHTS,
      mdaeMenuClickHandler:
        mdaiMenuClickHandlers.onAccessThoughtSpotAuditTargetAnalysesOP,
      visibleExpr: '!(hw.clientClaimType === "Professional")',
    },
    {
      menuId: 89,
      matchUrl: "/mdai/audittargetanalysesprofessional/",
      menuUrl: undefined,
      mdaiModule: MDAI_MODULE.AUDIT_INSIGHTS,
      mdaeMenuClickHandler:
        mdaiMenuClickHandlers.onAccessThoughtSpotAuditTargetAnalysesProfessional,
    },
    {
      menuId: 518,
      isOpenInNewTab: true,
    },
    {
      menuId: 520,
      isOpenInNewTab: true,
    },
    {
      menuId: 512,
      isMatchMenuUrlSearch: true,
      isReactMenu: true,
    },
    {
      menuId: 513,
      isMatchMenuUrlSearch: true,
      isReactMenu: true,
    },
    {
      mdaeMenuClickHandler: onSwitchToAnalyticsBellCurveReport,
      isReactMenu: true,
      menuId: 14,
    },
    {
      mdaeMenuClickHandler: onSwitchToAnalyticsBellCurveReport,
      isReactMenu: true,
      menuId: 35,
    },
    {
      menuId: 540,
      isReactMenu: true,
    },
    {
      menuId: 511,
      isOpenInNewTab: true,
    },
    {
      menuId: 537,
      isReactMenu: true,
    },
    {
      menuId: 510,
      isOpenInNewTab: true,
    },
    {
      menuId: 538,
      isReactMenu: true,
    },
    {
      menuId: 525,
      isReactMenu: true,
    },
    {
      menuId: 524,
      isReactMenu: true,
    },
    {
      menuId: 548,
      menuUrl: undefined,
      matchUrl: "/Analyzer/ConfigureDenialsPredictor",
      mdaiModule: MDAI_MODULE.REVENUE_OPTIMIZER,
      mdaeMenuClickHandler:
        mdaiMenuClickHandlers.onAccessThoughtspotiConfigureDenialsPredictor,
    },
    {
      menuId: 549,
      isReactMenu: true,
    },
    {
      menuId: 554,
      matchUrl: "/mdai/auditresultssummaryprovidergrouprisks/",
      menuUrl: undefined,
      mdaiModule: MDAI_MODULE.AUDIT_INSIGHTS,
      mdaeMenuClickHandler:
        mdaiMenuClickHandlers.onAccessThoughtSpotAuditResultsSummaryProviderGroupRisks,
    },
    {
      menuId: 553,
      menuUrl: undefined,
      mdaiModule: MDAI_MODULE.AUDIT_INSIGHTS,
      mdaeMenuClickHandler:
        mdaiMenuClickHandlers.onAccessThoughtSpotAuditResultsSummaryProviderGroupRisks,
    },
    {
      menuId: 552,
      menuUrl: undefined,
      mdaiModule: MDAI_MODULE.AUDIT_INSIGHTS,
      mdaeMenuClickHandler: mdaiMenuClickHandlers.OnAccessSpotIQAllResults,
    },
    {
      menuId: 551,
      matchUrl: "/mdai/SpotIQResults/",
      isMatchMenuUrlSearch: true,
      menuUrl: undefined,
      mdaiModule: MDAI_MODULE.AUDIT_INSIGHTS,
      mdaeMenuClickHandler: mdaiMenuClickHandlers.OnAccessSpotIQAllResults,
    },
    {
      menuId: 550,
      matchUrl: "/mdai/SpotIQResults?isforro=true",
      isMatchMenuUrlSearch: true,
      menuUrl: undefined,
      mdaiModule: MDAI_MODULE.REVENUE_OPTIMIZER,
      mdaeMenuClickHandler: mdaiMenuClickHandlers.OnAccessSpotIQRoAllResults,
    },
    {
      menuId: 545,
      menuUrl: undefined,
      matchUrl: "/mdai/selfsearch/",
      isMatchMenuUrlSearch: true,
      mdaiModule: MDAI_MODULE.AUDIT_INSIGHTS,
      mdaeMenuClickHandler:
        mdaiMenuClickHandlers.onAccessThoughtSpotSelfServiceSearch,
    },
    {
      menuId: 546,
      menuUrl: undefined,
      matchUrl: "/mdai/allinsights/",
      isMatchMenuUrlSearch: true,
      mdaiModule: MDAI_MODULE.AUDIT_INSIGHTS,
      mdaeMenuClickHandler:
        mdaiMenuClickHandlers.onAccessThoughtSpotAllInsights,
    },
    {
      menuId: 556,
      isReactMenu: true,
    },
    {
      menuId: 557,
      menuUrl: undefined,
      mdaiModule: MDAI_MODULE.EXTERNAL_AUDIT_INSIGHTS,
      mdaeMenuClickHandler: mdaiMenuClickHandlers.onAccessExternalAuditInsights,
    },
    {
      menuId: 558,
      menuUrl: undefined,
      matchUrl: "/externalaudit/mdai/departmentsummary",
      mdaiModule: MDAI_MODULE.EXTERNAL_AUDIT_INSIGHTS,
      mdaeMenuClickHandler: mdaiMenuClickHandlers.onAccessDepartmentSummary,
    },
    {
      menuId: 604,
      menuUrl: undefined,
      matchUrl: "/externalaudit/mdai/eawbenchmarks",
      mdaiModule: MDAI_MODULE.EXTERNAL_AUDIT_INSIGHTS,
      mdaeMenuClickHandler: mdaiMenuClickHandlers.onAccessEAWBenchmarks,
      isReactMenu: true,
    },
    {
      menuId: 559,
      menuUrl: undefined,
      matchUrl: "/externalaudit/mdai/requestersummary",
      mdaiModule: MDAI_MODULE.EXTERNAL_AUDIT_INSIGHTS,
      mdaeMenuClickHandler: mdaiMenuClickHandlers.onAccessRequesterSummary,
    },
    {
      menuId: 560,
      menuUrl: undefined,
      matchUrl: "/externalaudit/mdai/externalauditresults",
      mdaiModule: MDAI_MODULE.EXTERNAL_AUDIT_INSIGHTS,
      mdaeMenuClickHandler: mdaiMenuClickHandlers.onAccessExternalAuditResults,
    },
    {
      menuId: 561,
      menuUrl: undefined,
      matchUrl: "/externalaudit/mdai/externalaudittargets",
      mdaiModule: MDAI_MODULE.EXTERNAL_AUDIT_INSIGHTS,
      mdaeMenuClickHandler: mdaiMenuClickHandlers.onAccessExternalAuditTargets,
    },
    {
      menuId: 563,
      menuUrl: undefined,
      matchUrl: "/externalaudit/mdai/departmentsummary",
      mdaiModule: MDAI_MODULE.EXTERNAL_AUDIT_INSIGHTS,
      mdaeMenuClickHandler: mdaiMenuClickHandlers.onAccessDepartmentSummary,
    },
    {
      menuId: 564,
      menuUrl: undefined,
      matchUrl: "/externalaudit/mdai/requestersummary",
      mdaiModule: MDAI_MODULE.EXTERNAL_AUDIT_INSIGHTS,
      mdaeMenuClickHandler: mdaiMenuClickHandlers.onAccessRequesterSummary,
    },
    {
      menuId: 565,
      menuUrl: undefined,
      matchUrl: "/externalaudit/mdai/externalauditresults",
      mdaiModule: MDAI_MODULE.EXTERNAL_AUDIT_INSIGHTS,
      mdaeMenuClickHandler: mdaiMenuClickHandlers.onAccessExternalAuditResults,
    },
    {
      menuId: 566,
      menuUrl: undefined,
      matchUrl: "/externalaudit/mdai/externalaudittargets",
      mdaiModule: MDAI_MODULE.EXTERNAL_AUDIT_INSIGHTS,
      mdaeMenuClickHandler: mdaiMenuClickHandlers.onAccessExternalAuditTargets,
    },
    {
      menuId: 567,
      isReactMenu: true,
    },
    {
      menuId: 568,
      menuUrl: undefined,
      matchUrl: "/mdai/selfsearch?isforea=true",
      isMatchMenuUrlSearch: true,
      mdaiModule: MDAI_MODULE.EXTERNAL_AUDIT_INSIGHTS,
      mdaeMenuClickHandler:
        mdaiMenuClickHandlers.onAccessThoughtSpotEaSelfServiceSearch,
    },
    {
      menuId: 569,
      menuUrl: undefined,
      matchUrl: "/mdai/allinsights?isforea=true",
      isMatchMenuUrlSearch: true,
      mdaiModule: MDAI_MODULE.EXTERNAL_AUDIT_INSIGHTS,
      mdaeMenuClickHandler:
        mdaiMenuClickHandlers.onAccessThoughtSpotEaAllInsights,
    },
    {
      menuId: 570,
      menuUrl: undefined,
      matchUrl: "/mdai/SpotIQResults?isforea=true",
      isMatchMenuUrlSearch: true,
      mdaiModule: MDAI_MODULE.EXTERNAL_AUDIT_INSIGHTS,
      mdaeMenuClickHandler: mdaiMenuClickHandlers.OnAccessSpotEaIQAllResults,
    },
    {
      menuId: 571,
      menuUrl: undefined,
      matchUrl: "/mdai/selfsearch?isforea=true",
      isMatchMenuUrlSearch: true,
      mdaiModule: MDAI_MODULE.EXTERNAL_AUDIT_INSIGHTS,
      mdaeMenuClickHandler:
        mdaiMenuClickHandlers.onAccessThoughtSpotEaSelfServiceSearch,
    },
    {
      menuId: 572,
      menuUrl: undefined,
      matchUrl: "/mdai/allinsights?isforea=true",
      isMatchMenuUrlSearch: true,
      mdaiModule: MDAI_MODULE.EXTERNAL_AUDIT_INSIGHTS,
      mdaeMenuClickHandler:
        mdaiMenuClickHandlers.onAccessThoughtSpotEaAllInsights,
    },
    {
      menuId: 573,
      menuUrl: undefined,
      matchUrl: "/mdai/SpotIQResults?isforea=true",
      isMatchMenuUrlSearch: true,
      mdaiModule: MDAI_MODULE.EXTERNAL_AUDIT_INSIGHTS,
      mdaeMenuClickHandler: mdaiMenuClickHandlers.OnAccessSpotEaIQAllResults,
    },
    {
      menuId: 577,
      menuUrl: undefined,
    },
    {
      menuId: 578,
      matchUrl: "/mdai/procedureutilization/",
      menuUrl: undefined,
      mdaiModule: MDAI_MODULE.PROCEDURE_UTILIZATION,
      mdaeMenuClickHandler:
        mdaiMenuClickHandlers.onAccessThoughtpProcessUtilization,
    },
    {
      menuId: 579,
      menuUrl: undefined,
      matchUrl: "/mdai/selfsearch?isforpu=true",
      isMatchMenuUrlSearch: true,
      mdaiModule: MDAI_MODULE.PROCEDURE_UTILIZATION,
      mdaeMenuClickHandler:
        mdaiMenuClickHandlers.onAccessThoughtSpotPuSelfServiceSearch,
    },
    {
      menuId: 580,
      menuUrl: undefined,
      matchUrl: "/mdai/allinsights?isforpu=true",
      isMatchMenuUrlSearch: true,
      mdaiModule: MDAI_MODULE.PROCEDURE_UTILIZATION,
      mdaeMenuClickHandler:
        mdaiMenuClickHandlers.onAccessThoughtSpotPuAllInsights,
    },
    {
      menuId: 581,
      menuUrl: undefined,
      matchUrl: "/mdai/SpotIQResults?isforpu=true",
      isMatchMenuUrlSearch: true,
      mdaiModule: MDAI_MODULE.PROCEDURE_UTILIZATION,
      mdaeMenuClickHandler: mdaiMenuClickHandlers.OnAccessSpotIQPuAllResults,
    },
    {
      menuId: 585,
      isReactMenu: true,
    },
    {
      menuId: 587,
      matchUrl: "/mdai/procedureutilization/hospitalclaims",
      menuUrl: undefined,
      mdaiModule: MDAI_MODULE.PROCEDURE_UTILIZATION,
      mdaeMenuClickHandler:
        mdaiMenuClickHandlers.onAccessThoughtSpotProcessUtilizationHospitalClaims,
    },
    {
      menuId: 598,
      matchUrl: "/Analyzer/riskareas",
      isOpenInNewTab: true,
    },
    {
      menuId: 603,
      isReactMenu: true,
    },
    {
      menuId: 610,
      isReactMenu: true,
      matchUrl: "/externalaudit/emdrInbox",
      isOpenInNewTab: false,
    },
    {
      menuId: 613,
      matchUrl: "/mdai/auditroi/",
      menuUrl: undefined,
      mdaiModule: MDAI_MODULE.ROI_SUMMARY,
      mdaeMenuClickHandler: mdaiMenuClickHandlers.onAccessThoughtSpotAuditROI,
    },
    {
      menuId: 614,
      matchUrl: "/mdai/payerauditroi/",
      menuUrl: undefined,
      mdaiModule: MDAI_MODULE.ROI_SUMMARY,
      mdaeMenuClickHandler:
        mdaiMenuClickHandlers.onAccessThoughtSpotPayerAuditROI,
    },
    {
      menuId: 615,
      matchUrl: "/mdai/chargepaymentanalyses/",
      menuUrl: undefined,
      mdaiModule: MDAI_MODULE.REVENUE_OPTIMIZER,
      mdaeMenuClickHandler:
        mdaiMenuClickHandlers.onAccessThoughtSpotChargePaymentAnalysesReports,
    },
    {
      menuId: 616,
      isReactMenu: true,
      matchUrl: "/externalaudit/emdrenrollment",
      isOpenInNewTab: false,
    },
    {
      menuId: 620,
      isReactMenu: true,
      matchUrl: "/externalaudit/admin/targetrationale",
      isOpenInNewTab: false,
    },
    {
      menuId: 621,
      isReactMenu: true,
      matchUrl: "/externalaudit/caselist",
      isOpenInNewTab: false,
    },
    {
      menuId: 622,
      isReactMenu: true,
      matchUrl: "/externalaudit/casesearch",
      isOpenInNewTab: false,
    },
    {
      menuId: 623,
      isReactMenu: true,
      matchUrl: "/customersetup/dataconfiguration",
      isOpenInNewTab: false,
    },
    {
      menuId: 624,
      isReactMenu: true,
      matchUrl: "/externalaudit/customersetup/dataconfiguration",
      isOpenInNewTab: false,
    },
    {
      menuId: 625,
      matchUrl: "/mdai/professionalproviderrisk/",
      menuUrl: undefined,
      mdaiModule: MDAI_MODULE.REVENUE_OPTIMIZER,
      mdaeMenuClickHandler:
        mdaiMenuClickHandlers.onAccessThoughtSpotProfessionalProviderRisk,
    },
    {
      menuId: 626,
      matchUrl: "/mdai/professionalcoderrisk/",
      menuUrl: undefined,
      mdaiModule: MDAI_MODULE.REVENUE_OPTIMIZER,
      mdaeMenuClickHandler:
        mdaiMenuClickHandlers.onAccessThoughtSpotProfessionalCoderRisk,
    },
    {
      menuId: 627,
      matchUrl: "/mdai/professionalpayerrisk/",
      menuUrl: undefined,
      mdaiModule: MDAI_MODULE.REVENUE_OPTIMIZER,
      mdaeMenuClickHandler:
        mdaiMenuClickHandlers.onAccessThoughtSpotProfessionalPayerRisk,
    },
    {
      menuId: 628,
      matchUrl: "/mdai/professionaltopcodes/",
      menuUrl: undefined,
      mdaiModule: MDAI_MODULE.REVENUE_OPTIMIZER,
      mdaeMenuClickHandler:
        mdaiMenuClickHandlers.onAccessThoughtSpotProfessionalTopCodes,
    },
    {
      menuId: 629,
      matchUrl: "/mdai/outpatientfacilityrisk/",
      menuUrl: undefined,
      mdaiModule: MDAI_MODULE.REVENUE_OPTIMIZER,
      mdaeMenuClickHandler:
        mdaiMenuClickHandlers.onAccessThoughtSpotOutpatientFacilityRisk,
    },
    {
      menuId: 630,
      matchUrl: "/mdai/outpatientcoderrisk/",
      menuUrl: undefined,
      mdaiModule: MDAI_MODULE.REVENUE_OPTIMIZER,
      mdaeMenuClickHandler:
        mdaiMenuClickHandlers.onAccessThoughtSpotOutpatientCoderRisk,
    },
    {
      menuId: 631,
      matchUrl: "/mdai/outpatientpayerrisk/",
      menuUrl: undefined,
      mdaiModule: MDAI_MODULE.REVENUE_OPTIMIZER,
      mdaeMenuClickHandler:
        mdaiMenuClickHandlers.onAccessThoughtSpotOutpatientPayerRisk,
    },
    {
      menuId: 632,
      matchUrl: "/mdai/outpatienttopcodes/",
      menuUrl: undefined,
      mdaiModule: MDAI_MODULE.REVENUE_OPTIMIZER,
      mdaeMenuClickHandler:
        mdaiMenuClickHandlers.onAccessThoughtSpotOutpatientTopCodes,
    },
    {
      menuId: 633,
      matchUrl: "/mdai/inpatientfacilityrisk/",
      menuUrl: undefined,
      mdaiModule: MDAI_MODULE.REVENUE_OPTIMIZER,
      mdaeMenuClickHandler:
        mdaiMenuClickHandlers.onAccessThoughtSpotInpatientFacilityRisk,
    },
    {
      menuId: 634,
      matchUrl: "/mdai/inpatientcoderrisk/",
      menuUrl: undefined,
      mdaiModule: MDAI_MODULE.REVENUE_OPTIMIZER,
      mdaeMenuClickHandler:
        mdaiMenuClickHandlers.onAccessThoughtSpotInpatientCoderRisk,
    },
    {
      menuId: 635,
      matchUrl: "/mdai/inpatientpayerrisk/",
      menuUrl: undefined,
      mdaiModule: MDAI_MODULE.REVENUE_OPTIMIZER,
      mdaeMenuClickHandler:
        mdaiMenuClickHandlers.onAccessThoughtSpotInpatientPayerRisk,
    },
    {
      menuId: 636,
      matchUrl: "/mdai/inpatienttopcodes/",
      menuUrl: undefined,
      mdaiModule: MDAI_MODULE.REVENUE_OPTIMIZER,
      mdaeMenuClickHandler:
        mdaiMenuClickHandlers.onAccessThoughtSpotInpatientTopCodes,
    },
    {
      menuId: 638,
      isReactMenu: true,
      matchUrl: "/policysearch",
      isOpenInNewTab: true,
    },
    {
      menuId: 640,
      isReactMenu: true,
      matchUrl: "/analyzer/policysearch",
      isOpenInNewTab: true,
    },
    {
      menuId: 642,
      isReactMenu: true,
      matchUrl: "/externalaudit/policysearch",
      isOpenInNewTab: true,
    },
  ],
  selectMdaeDxMenuListItem: function(dxMenuListInstance, currentPathName) {
    if (dxMenuListInstance) {
      const currentMenuItem = mdaeNewNavigationBarConfig.getMenuItemForGivenPathname(
        dxMenuListInstance.option("items"),
        currentPathName
      );
      if (currentMenuItem) {
        dxMenuListInstance.selectItem(currentMenuItem.dxListItemIndex);
        dxMenuListInstance.scrollTo(currentMenuItem.dxListItemIndex * 35);
        dxMenuListInstance.option(
          "items[" + currentMenuItem.dxListItemIndex + "].selected",
          true
        );
        return currentMenuItem;
      }
    }
  },
  getMenuItemForGivenPathname: function(menuItemList, currentMenuUrl) {
    let dxListItemIndex = -1;
    const getMenuItemForGivenFilePath = (menuList) => {
      for (let index = 0; index < menuList.length; index++) {
        if (
          menuList[index].menuUrl &&
          mdaeNewNavigationBarConfig.isCurrentURL(
            currentMenuUrl,
            menuList[index].matchUrl || menuList[index].menuUrl,
            menuList[index].isMatchMenuUrlSearch
          )
        ) {
          dxListItemIndex = index;
          return menuList[index];
        }

        if (menuList[index].items && menuList[index].items.length) {
          let temMenuItem = getMenuItemForGivenFilePath(menuList[index].items);
          dxListItemIndex = index;
          if (temMenuItem) return temMenuItem;
        }
      }
    };
    let menuItem = getMenuItemForGivenFilePath(menuItemList);
    if (menuItem)
      return { menuItem: menuItem, dxListItemIndex: dxListItemIndex };
  },
  isCurrentURL: function(
    currentMenuUrl,
    menuUrl,
    isMatchMenuUrlSearch = false
  ) {
    var removeSlashesFromUrl = function(pathname) {
      var pathnameCharacters = pathname.split("");
      if (pathnameCharacters[0] === "/") {
        pathname = pathname.slice(1, pathname.length);
      }
      if (pathnameCharacters[pathnameCharacters.length - 1] === "/") {
        pathname = pathname.slice(0, pathname.length - 1);
      }
      return pathname.toLocaleLowerCase();
    };
    var currentURL = new URL(window.location.origin + currentMenuUrl);
    var menuURL = new URL(window.location.origin + menuUrl);
    var isMatchingUrl =
      removeSlashesFromUrl(currentURL.pathname) ===
      removeSlashesFromUrl(menuURL.pathname);
    if ((menuURL.search || currentURL.search) && isMatchMenuUrlSearch) {
      isMatchingUrl =
        menuURL.search.toLocaleLowerCase() ===
        currentURL.search.toLocaleLowerCase();
    }
    return isMatchingUrl;
  },
  hasItemAnySubmenu: function(auditsSectionMenuItemListItem) {
    return (
      auditsSectionMenuItemListItem.items &&
      auditsSectionMenuItemListItem.items.length
    );
  },
  getFormattedMdaiMenuHandlers: (
    mdaiBaseUrl,
    mdaiSecretKey,
    mdaiAIUserName,
    mdaiROUserName,
    mdaiEAUserName,
    mdaiPUUserName,
    mdaiROIUserName,
    adminUser,
    mdaiModule,
    clickHandler,
    dispatch,
    history
  ) => {
    if (
      mdaiModule === MDAI_MODULE.AUDIT_INSIGHTS ||
      mdaiModule == MDAI_MODULE.REVENUE_OPTIMIZER ||
      mdaiModule == MDAI_MODULE.EXTERNAL_AUDIT_INSIGHTS ||
      mdaiModule == MDAI_MODULE.PROCEDURE_UTILIZATION ||
      mdaiModule == MDAI_MODULE.ROI_SUMMARY
    ) {
      return () => {
        const mdaiSettings: IMdaiSettings = {
          mdaiBaseUrl: mdaiBaseUrl,
          mdaiSecretKey: mdaiSecretKey,
          mdaiAIUserName: mdaiAIUserName,
          mdaiROUserName: mdaiROUserName,
          mdaiEAUserName: mdaiEAUserName,
          mdaiPUUserName: mdaiPUUserName,
          mdaiROIUserName: mdaiROIUserName,
          adminUser: adminUser,
          mdaiModule: mdaiModule,
          dispatch: dispatch,
          history: history,
        };
        clickHandler(mdaiSettings);
      };
    }
  },
  processNewMenuItemListDataSource: function(
    auditsSectionMenuItemList,
    mdaiBaseUrl,
    mdaiSecretKey,
    mdaiAIUserName,
    mdaiROUserName,
    mdaiEAUserName,
    mdaiPUUserName,
    mdaiROIUserName,
    isTaskHQAccessEnabled,
    adminUser,
    dispatch,
    history,
    conditionsForPUMenuItems
  ) {
    let id = 0;
    const addIdToSubItems = function(items, rootId, rootParentName) {
      items.forEach((element) => {
        id += 1;
        element.id = id;
        element.rootMenuItemId = rootId;

        const staticMenuConfig = getMatchingUrlStaticConfig(element.menuId);
        if (staticMenuConfig) {
          for (let prop in staticMenuConfig) {
            if (prop != "menuUrl") element[prop] = staticMenuConfig[prop];
          }
          const mdaiClickHandler = mdaeNewNavigationBarConfig.getFormattedMdaiMenuHandlers(
            mdaiBaseUrl,
            mdaiSecretKey,
            mdaiAIUserName,
            mdaiROUserName,
            mdaiEAUserName,
            mdaiPUUserName,
            mdaiROIUserName,
            adminUser,
            staticMenuConfig.mdaiModule,
            staticMenuConfig.mdaeMenuClickHandler,
            dispatch,
            history
          );
          if (typeof mdaiClickHandler === "function") {
            element.mdaeMenuClickHandler = mdaiClickHandler;
          }
        }

        if (!(element.items && element.items.length)) delete element.items;
        if (element.items)
          addIdToSubItems(element.items, rootId, rootParentName);
      });
    };
    auditsSectionMenuItemList.forEach((element, index) => {
      id += 1;
      element.id = id;

      if (
        index > 0 &&
        !element.menuSectionTitle &&
        auditsSectionMenuItemList[index - 1].menuSectionTitle &&
        auditsSectionMenuItemList[index - 1].visible === false
      ) {
        element.menuSectionTitle =
          auditsSectionMenuItemList[index - 1].menuSectionTitle;
      }
      if (
        index > 0 &&
        !element.menuSectionTitle &&
        auditsSectionMenuItemList[index].menuSectionTitleDescription &&
        auditsSectionMenuItemList[index - 1].menuSectionTitleDescription !=
          auditsSectionMenuItemList[index].menuSectionTitleDescription
      ) {
        element.menuSectionTitle =
          auditsSectionMenuItemList[index].menuSectionTitleDescription;
      }

      element.isMainMenuListItem = true;
      element.selected = false;
      if (!(element.items && element.items.length)) delete element.items;
      if (element.items && element.items.length) {
        addIdToSubItems(element.items, id, element.parentName);

        if (element.title && element.title.toLowerCase() === "qa review") {
          var visibleItemMenuIndex = -1;
          var visibleMenuItemCount = 0;
          for (var i = 0; i < element.items.length; i++) {
            visibleMenuItemCount++;
            visibleItemMenuIndex = i;
          }
          if (visibleMenuItemCount === 1) {
            for (var prop in element.items[visibleItemMenuIndex]) {
              element[prop] = element.items[visibleItemMenuIndex][prop];
            }
            element.items = undefined;
          }
        }

        if (element.items?.length) {
          element.items.forEach((item, index) => {
            if (
              item.menuSectionTitle?.toLowerCase() == "procedure utilization"
            ) {
              if (
                (!conditionsForPUMenuItems.hasHospitalWorkFlowEnabled ||
                  (!conditionsForPUMenuItems.dataFeed837IEnableInd &&
                    !conditionsForPUMenuItems.dataFeedNonEDIClaimsEnableInd)) &&
                (!conditionsForPUMenuItems.hasProfessionalWorkFlowEnabled ||
                  (!conditionsForPUMenuItems.dataFeed837PEnableInd &&
                    !conditionsForPUMenuItems.dataFeedNonEDIClaimsEnableInd))
              ) {
                item.visible = false;
              }
            }
            if (
              item.menuName &&
              item.menuName?.toLowerCase() == "hospital claims"
            ) {
              if (
                !conditionsForPUMenuItems.hasHospitalWorkFlowEnabled ||
                (!conditionsForPUMenuItems.dataFeed837IEnableInd &&
                  !conditionsForPUMenuItems.dataFeedNonEDIClaimsEnableInd)
              ) {
                item.visible = false;
              }
            }
            if (
              item.menuName &&
              item.menuName?.toLowerCase() == "professional claims"
            ) {
              if (
                !conditionsForPUMenuItems.hasProfessionalWorkFlowEnabled ||
                (!conditionsForPUMenuItems.dataFeed837PEnableInd &&
                  !conditionsForPUMenuItems.dataFeedNonEDIClaimsEnableInd)
              ) {
                item.visible = false;
              }
            }
          });
        }

        if (
          element.menuName &&
          element.menuName.toLowerCase() == "audit insights" &&
          mdaiAIUserName == null
        ) {
          element.visible = false;
        }
        if (
          element.menuName &&
          element.menuName.toLowerCase() == "denial risks" &&
          mdaiROUserName == null
        ) {
          element.visible = false;
        }
        if (
          element.menuName &&
          element.menuName.toLowerCase() == "payer audit insights" &&
          mdaiEAUserName == null
        ) {
          element.visible = false;
        }
        if (
          element.menuName &&
          element.menuName.toLowerCase() == "procedure utilization" &&
          mdaiPUUserName == null
        )
          if (
            element.menuName &&
            element.menuName.toLowerCase() == "executive roi summary" &&
            mdaiROIUserName == null
          ) {
            element.visible = false;
          }
      } else {
        if (
          element.title &&
          element.title.toLowerCase() === "task hq" &&
          !isTaskHQAccessEnabled
        ) {
          element.visible = false;
        }
        const staticMenuConfig = getMatchingUrlStaticConfig(element.menuId);
        if (staticMenuConfig) {
          for (let prop in staticMenuConfig) {
            if (prop != "menuUrl") element[prop] = staticMenuConfig[prop];
          }

          const mdaiClickHandler = mdaeNewNavigationBarConfig.getFormattedMdaiMenuHandlers(
            mdaiBaseUrl,
            mdaiSecretKey,
            mdaiAIUserName,
            mdaiROUserName,
            mdaiEAUserName,
            mdaiPUUserName,
            mdaiROIUserName,
            adminUser,
            staticMenuConfig.mdaiModule,
            staticMenuConfig.mdaeMenuClickHandler,
            dispatch,
            history
          );
          if (typeof mdaiClickHandler === "function") {
            element.mdaeMenuClickHandler = mdaiClickHandler;
          }
        }
      }
    });
    return auditsSectionMenuItemList;
  },
};
export { mdaeNewNavigationBarConfig };
